import React from 'react'

const SixTen = ({ sixTen }) => {
    return (
        <div className='time-stamp space-y-2'>
            <label className='late'>6PM- 10PM &#8594; <span>{sixTen.pct + "%"}</span></label>
            <div><span className='font-semibold'>Total Sales:</span> {sixTen.total_count} X <span>{sixTen.total_sales}</span></div>
            <div className='numbers space-y-2'>
                <div><span>Dine-In : </span> {sixTen.dinein_sales === 'None' ? "-" : <>{sixTen.dinein_count} X {sixTen.dinein_sales}</>}</div>
                <div><span>Order : </span>{sixTen.tab_sales === 'None' ? "-" : <>{sixTen.tab_count} X {sixTen.tab_sales}</>}</div>
            </div>
        </div>
    )
}

export default SixTen